import WithRender from "../../templates/buttons/quotationButton.html";
import { mapGetters, mapActions } from "vuex";
import axios from "../../axios-auth";

export default WithRender({
  computed: {
    ...mapGetters([
      "getSelectionId",
      "getIsQuotationUrlSet",
      "getQuantities",
      "getChangeOptionsDataPPOpt",
      "getHideQuotationButton",
      "getIsChangeOptionsLoading",
      "getIsCimpressSelectionResolved",
      "getFilesConnectLoading"
    ]),
    getDisableClass: function () {
      return this.getIsChangeOptionsLoading ||
        this.getFilesConnectLoading ||
        !this.getIsCimpressSelectionResolved
        ? "disabled"
        : "";
    },
    name: function () {
      return "Quotation";
    },
    showButton: function () {
      return !this.getHideQuotationButton && this.getIsQuotationUrlSet;
    }
  },
  methods: {
    ...mapActions(["openFancybox"]),
    quotationButton: function () {
      var _qtys = this.getQuantities;
      for (var i = 0; i < _qtys.length; i++) {
        if (typeof _qtys[i].formatted_base_price != "undefined") {
          _qtys[i].formatted_base_price = "";
        }
        if (typeof _qtys[i].formatted_price_per_unit != "undefined") {
          _qtys[i].formatted_price_per_unit = "";
        }
      }
      var _data = [this.getChangeOptionsDataPPOpt, _qtys];
      var url =
        this.$store.getters.getUrl(axios.quotationUrl) +
        "?selection=" +
        btoa(unescape(encodeURIComponent(JSON.stringify(_data))));

      this.openFancybox({ src: url });
    }
  }
});
